import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from '../../../../withRouter'
import dayjs from 'dayjs'
import { colors } from '@lmc/common/constants'
import { Icon, ProfilePicture } from '../../../../components/generic'
import { history } from '../../../../store'

export class CarePlanReportsItem extends React.Component {
  state = {
    isAlert: null,
    isOverdue: null,
    resident: null,
  }

  componentDidMount() {
    const { carePlans } = this.props
    if (!carePlans || !carePlans.length) return null

    const dueDate = dayjs(carePlans[0].nextReviewDate)

    const isAlert = dueDate.isBefore(dayjs().add(1, 'days').startOf('day'))
    const isOverdue = dueDate.isBefore(dayjs().startOf('day'))
    const resident = carePlans[0].resident

    this.setState({ isAlert, isOverdue, resident })
  }

  redirect = () => {
    history.push(`/residents/${this.state.resident.id}/care-plans`)
  }

  renderAdl = (carePlan, i) => {
    const { isOverdue } = this.state

    const adlName = carePlan.customName
      ? carePlan.customName
      : carePlan.carePlanAdl
      ? carePlan.carePlanAdl.name
      : null

    if (!adlName) return null

    const alert = carePlan.alert && carePlan.alert.text

    let adlText = `${adlName}`
    if (alert) adlText += ` • ${alert}`
    if (isOverdue) {
      const dateDiff = dayjs().diff(carePlan.nextReviewDate, 'days')
      const overdueText = `Overdue +${dateDiff} days`
      return (
        <div key={i} style={styles.adlText}>
          <span style={styles.overdue}>{overdueText}</span> • {adlText}
        </div>
      )
    } else {
      return (
        <div key={i} style={styles.adlText}>
          {adlText}
        </div>
      )
    }
  }

  renderIcon = () => {
    const { isAlert } = this.state

    const icon = isAlert ? 'incident' : 'clock'
    const color = isAlert ? colors.red : colors.orange

    return (
      <div style={styles.iconContainer}>
        <span style={styles.count}>{this.props.carePlans.length}</span>
        <Icon fill={color} name={icon} style={styles.icon} />
      </div>
    )
  }

  render() {
    const { carePlans, router, style } = this.props
    const { resident } = this.state
    if (
      !carePlans ||
      !carePlans.length ||
      !resident ||
      !resident.name ||
      !router
    )
      return null

    return (
      <div
        className="lmc-list-item"
        style={{
          ...styles.wrapper,
          ...style,
        }}
      >
        <div
          className="lmc-list-item-link-container"
          onClick={this.redirect}
          style={styles.mainInfoContainer}
        >
          <ProfilePicture
            url={resident.picture}
            style={styles.profilePicture}
            type="small"
          />
          <div
            className="lmc-list-item-parent-link"
            style={styles.residentNameContainer}
          >
            <span className="lmc-list-item-link" style={styles.residentName}>
              {resident.name.first} {resident.name.last}
            </span>
            <div style={styles.adlsContainer}>
              {carePlans.map(this.renderAdl)}
            </div>
          </div>
        </div>
        <div>{this.renderIcon()}</div>
      </div>
    )
  }
}

const styles = {
  adlText: {
    color: colors.darkgrey,
  },
  icon: {
    marginLeft: 12,
  },
  iconContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  mainInfoContainer: {
    cursor: 'pointer',
    display: 'flex',
    flex: 1,
    minWidth: 200,
    paddingBottom: 2,
  },
  overdue: {
    color: colors.red,
  },
  residentNameContainer: {
    overflow: 'hidden',
    paddingRight: 12,
    textOverflow: 'ellipsis',
  },
  profilePicture: {
    border: 'none',
    flexShrink: 0,
    margin: '0px 12px 0px 0px',
  },
  residentName: {
    fontSize: 16,
    fontWeight: 'bold',
    overflow: 'hidden',
    minWidth: 0,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  wrapper: {
    display: 'flex',
    minWidth: 250,
    margin: 0,
    padding: '8px 13px',
  },
}

CarePlanReportsItem.propTypes = {
  carePlans: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default withRouter(CarePlanReportsItem)
